module.exports = __webpack_public_path__ + "static/media/currentView.97e76e92.gif";